var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 2.66699H2.66659C2.31296 2.66699 1.97382 2.80747 1.72378 3.05752C1.47373 3.30756 1.33325 3.6467 1.33325 4.00033V13.3337C1.33325 13.6873 1.47373 14.0264 1.72378 14.2765C1.97382 14.5265 2.31296 14.667 2.66659 14.667H11.9999C12.3535 14.667 12.6927 14.5265 12.9427 14.2765C13.1928 14.0264 13.3333 13.6873 13.3333 13.3337V8.66699",
    stroke: "#2A2A2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 1.66714C12.5985 1.40193 12.9582 1.25293 13.3333 1.25293C13.7083 1.25293 14.068 1.40193 14.3333 1.66714C14.5985 1.93236 14.7475 2.29207 14.7475 2.66714C14.7475 3.04222 14.5985 3.40193 14.3333 3.66714L7.99992 10.0005L5.33325 10.6671L5.99992 8.00048L12.3333 1.66714Z",
    stroke: "#2A2A2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1befb2e5fbf190f99f6f96cf55f3759c.svg";
export { ForwardRef as ReactComponent };